import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../AuthContext';
import { useVersionedApi } from '../utils/versionedApi';

/** Server-authoritative access to clinical supervisor review and approval. */
export function useClinicalApprovalAccess() {
  const apiClient = useVersionedApi('v1');
  const { user } = useAuth() || {};
  const query = useQuery({
    queryKey: ['clinical-approval-access', user?.organizationId, user?.id || user?.userId],
    queryFn: async () => {
      const response = await apiClient.get('/clinical/approval-access');
      return response.data?.canApprove === true;
    },
    enabled: Boolean(user),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  return {
    canApproveClinicalDocuments: query.data === true,
    loading: query.isPending,
    error: query.error || null,
  };
}

export default useClinicalApprovalAccess;
